import axios from 'axios';
import { apiPaths } from 'constants/path';
import { tokenHeader } from 'functions/apiFunctions';
import { GetAssessmentPaymentApiType } from 'models/Admin/AdminAssessmentPaymentTypes';

class AdminAssessmentPaymentPageApi {
    async getAssessmentPaymentList(
        page: number | null, 
        searchValue: string | null, 
        token: string, 
        searchType: number | null,
        startDate?: string | null,
        endDate?: string | null,
    ): Promise<GetAssessmentPaymentApiType> {
        let url = `${apiPaths.getAssessmentPayment}?page=${page}&limit=${11}`;
        
        // searchValue가 있을 때만 searchType과 searchKeyword 파라미터 추가
        if (searchValue && searchValue.trim() !== '') {
            url += `&searchType=${searchType}&searchKeyword=${searchValue}`;
        }

        if (startDate) {
            url += `&startDate=${startDate}`;
        }
        
        if (endDate) {
            url += `&endDate=${endDate}`;
        }

        console.log(startDate);
        console.log(endDate);

        console.log(url);
        
        try {
            const resopnse = await axios.get(url, { headers: tokenHeader(token) });
            console.log(resopnse.data.data);
            return resopnse.data;
        } catch (error) {
            throw error;
        }
    }

    // TODO: 추후 범용적인 업데이트로 수정 필요
    async updateAssessmentPayment(id: string, isTest: boolean, token: string): Promise<any> {
        const url = `${apiPaths.updateAssessmentPayment}/${id}`;
        try {
            const response = await axios.put(url, { isTest }, { headers: tokenHeader(token) });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getAssessmentPaymentListForExcel(
        searchValue: string | null, 
        token: string, 
        searchType: number | null,
        startDate?: string | null,
        endDate?: string | null,
    ): Promise<GetAssessmentPaymentApiType> {
        let url = `${apiPaths.getAssessmentPayment}`;
        
        // searchValue가 있을 때만 searchType과 searchKeyword 파라미터 추가
        if (searchValue && searchValue.trim() !== '') {
            url += `?searchType=${searchType}&searchKeyword=${searchValue}`;
        }
        
        // 날짜 파라미터 추가
        const hasSearchParams = searchValue && searchValue.trim() !== '';
        if (startDate) {
            url += hasSearchParams ? `&startDate=${startDate}` : `?startDate=${startDate}`;
        }
        
        if (endDate) {
            url += (hasSearchParams || startDate) ? `&endDate=${endDate}` : `?endDate=${endDate}`;
        }

        try {
            const response = await axios.get(url, { headers: tokenHeader(token) });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export const adminAssessmentPaymentPageApi = new AdminAssessmentPaymentPageApi();
